import { render, staticRenderFns } from "./BalancesFilter.vue?vue&type=template&id=71a48d26&"
import script from "./BalancesFilter.vue?vue&type=script&lang=ts&"
export * from "./BalancesFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports